export const getLoggingEnabledSecondsForLowPrioResources = ({
  sampleRate,
}: {
  sampleRate: number;
}) => {
  const totalSeconds = 60 * sampleRate;
  const splitSecond = Math.ceil(60 / totalSeconds);
  const secondsDuringWhichLoggingIsEnabled = Array.from(
    {length: totalSeconds},
    (_, i) => i * splitSecond + 1,
  );

  return new Set(secondsDuringWhichLoggingIsEnabled);
};
